import finishFreePlayCompletedLevelResponse from './data/finishFreePlay/completed-level.json';
import finishFreePlayLetterPartyStarProgressResponse from './data/finishFreePlay/letter-party-three-star-progress.json';
import finishFreePlayThreeStarProgressResponse from './data/finishFreePlay/three-star-progress.json';
import letterPartyPlaylistResponse from './data/playlist/letter-party-playlist-response.json';
import timeGamePlaylistResponse from './data/playlist/time-game-playlist-response.json';
import playlistSectionAnswerResponse from './data/playlistSectionAnswers/create-response.json';
import storePlaylistSectionAnswerTimeResponse from './data/playlistSectionAnswerTimes/update-response.json';

import type { AxiosResponse } from 'axios';

type RequestFactory<TData> = () => Promise<AxiosResponse<TData>>;

interface FreePlayRequestParams {
	freePlayCategoryId?: number | string | null;
}

export const DUMMY_DATA_SCENARIOS = {
	playFreePlayTimeGameWithCompletedLevel: false,
	playFreePlayTimeGameWithStarProgress: false,
	playFreePlayLetterPartyWithStarProgress: false,
};

const isFreePlayRequest = ({ freePlayCategoryId }: FreePlayRequestParams) =>
	freePlayCategoryId !== undefined && freePlayCategoryId !== null;

const isFreePlayGameScenarioEnabled = () =>
	DUMMY_DATA_SCENARIOS.playFreePlayTimeGameWithCompletedLevel ||
	DUMMY_DATA_SCENARIOS.playFreePlayTimeGameWithStarProgress ||
	DUMMY_DATA_SCENARIOS.playFreePlayLetterPartyWithStarProgress;

export const shouldUsePlaylistDummyData = (params: FreePlayRequestParams = {}) =>
	isFreePlayRequest(params) && isFreePlayGameScenarioEnabled();

export const getDummyPlaylistResponse = (params: FreePlayRequestParams = {}) => {
	if (!shouldUsePlaylistDummyData(params)) {
		return undefined;
	}

	if (DUMMY_DATA_SCENARIOS.playFreePlayLetterPartyWithStarProgress) {
		return letterPartyPlaylistResponse;
	}

	return timeGamePlaylistResponse;
};

export const getDummyFinishFreePlayResponse = (params: FreePlayRequestParams = {}) => {
	if (!shouldUsePlaylistDummyData(params)) {
		return undefined;
	}

	if (DUMMY_DATA_SCENARIOS.playFreePlayTimeGameWithStarProgress) {
		return finishFreePlayThreeStarProgressResponse;
	}

	if (DUMMY_DATA_SCENARIOS.playFreePlayLetterPartyWithStarProgress) {
		return finishFreePlayLetterPartyStarProgressResponse;
	}

	return finishFreePlayCompletedLevelResponse;
};

export const getDummyPlaylistSectionAnswerResponse = () =>
	isFreePlayGameScenarioEnabled() ? playlistSectionAnswerResponse : undefined;

export const getDummyStorePlaylistSectionAnswerTimeResponse = () =>
	isFreePlayGameScenarioEnabled() ? storePlaylistSectionAnswerTimeResponse : undefined;

function createDummyAxiosResponse<TData>(data: TData): AxiosResponse<TData> {
	return {
		data,
		status: 200,
		statusText: 'OK',
		headers: {},
		config: {
			headers: {},
		} as AxiosResponse<TData>['config'],
	};
}

export function requestWithDummyData<TData>(
	dummyData: TData | undefined,
	request: RequestFactory<TData>,
): Promise<AxiosResponse<TData>> {
	if (dummyData !== undefined) {
		return Promise.resolve(createDummyAxiosResponse(dummyData));
	}

	return request();
}
